import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";
import { APP_ROUTES } from "../../routes/AppRoutes";
// Placeholder photos until the final images are ready.
import brandImg from "../../assets/images/whatwedo/celebrityMarketing/brand.jpg";
import hostImg from "../../assets/images/whatwedo/celebrityMarketing/event.jpg";

const OPTIONS = [
  { image: brandImg, kicker: "For brands", title: "I'm a Brand", desc: "Create attention, build brand love and drive impact with the right celebrity." },
  { image: hostImg, kicker: "For hosts", title: "I'm Hosting an Event", desc: "Bring a celebrity to your wedding, private event, corporate event or launch." },
];

const n = OPTIONS.length;
const pad = (i) => String(i).padStart(2, "0");

const CelebAudience = () => {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => setActive((a) => (a + 1) % n), 4000);
    return () => clearInterval(timer);
  }, [active]); // a click restarts the countdown

  const { image, kicker, title, desc } = OPTIONS[active];

  return (
    <section className="ee-section cm-audience">
      <div className="container">
        <h2 className="ee-title" data-aos="fade-up" data-aos-once="true">
          Choose what best <span>describes your requirement.</span>
        </h2>

        <div className="cm-aud">
          <div className="cm-aud-side">
            <div className="cm-aud-meta">
              <span className="cm-aud-count">{pad(active + 1)} / {pad(n)}</span>
              <span className="cm-aud-label">Who are you planning for?</span>
            </div>
            <div className="cm-aud-thumbs">
              {OPTIONS.map((o, i) =>
                i === active ? null : (
                  <button type="button" key={o.title} className="cm-aud-thumb" onClick={() => setActive(i)} aria-label={o.title}>
                    <img loading="lazy" decoding="async" src={o.image} alt="" />
                  </button>
                )
              )}
            </div>
          </div>

          {/* Re-keyed on change so the new photo and text animate in. */}
          <div className="cm-aud-photo" key={`photo-${active}`}>
            <img loading="lazy" decoding="async" src={image} alt="" />
          </div>

          <div className="cm-aud-text" key={`text-${active}`}>
            <strong>{title}</strong>
            <small>{kicker}</small>
            <p>{desc}</p>
            <div className="cm-aud-actions">
              <button type="button" className="cm-aud-next" onClick={() => setActive((a) => (a + 1) % n)} aria-label="Next">
                <ChevronRight size={20} />
              </button>
              <Link to={APP_ROUTES.CONTACT_US} className="cm-aud-link">
                Talk to us <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CelebAudience;
